import {getEnv} from '../../common/env/env';
import {ItemSetDto} from '../../common/shared/api/gateway/ItemSetDto.interface';
import {LandingPageVo} from '../../common/shared/api/karina/vo/page/LandingPageVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {
  ContentsType,
  Maybe,
  SetListViewLandingList,
  User,
} from '../generated/types';
import {createNormalListViewItem} from './NormalListViewItem';

export function createSetListViewLandingList(
  userInfo: Maybe<User>,
  landingPage: LandingPageVo<ItemSetDto>,
  id: string,
  page: number
): SetListViewLandingList {
  return {
    id,
    isEnd: landingPage.is_end,
    totalCount: landingPage.total_count,
    type: ContentsType.Set,
    list: landingPage.list.map(item =>
      createNormalListViewItem(userInfo, {
        listViewLandingItemSetDto: item,
      })
    ),
    title: landingPage.title,
    topImage: landingPage.top_image
      ? getKageUrl({
          kageId: landingPage.top_image,
          kageUrlPrefix: getEnv().kageUrlPrefix,
          resolution: 'o1',
        })
      : undefined,
    page,
  };
}
